"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrHeaderLogo = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const fdr_regular_basis_fdr_image_1 = require("@hotelplan/fdr.regular.basis.fdr-image");
const fdr_regular_basis_fdr_route_1 = require("@hotelplan/fdr.regular.basis.fdr-route");
const HeaderLogoLink = (0, styled_components_1.default)(fdr_regular_basis_fdr_route_1.FdrRoute)(({ theme }) => theme.header.logo);
const Logo = (0, styled_components_1.default)(fdr_regular_basis_fdr_image_1.FdrImage).attrs({
    lazy: false,
    loading: `eager`,
})({});
const FdrHeaderLogo = ({ logo, logoRouterProps }) => {
    return logo ? (react_1.default.createElement(HeaderLogoLink, Object.assign({}, logoRouterProps),
        react_1.default.createElement(Logo, { image: logo, testId: "header-logo" }))) : null;
};
exports.FdrHeaderLogo = FdrHeaderLogo;
//# sourceMappingURL=fdr-header-logo.js.map